import React, { useEffect } from 'react';

const TimeOffAnalytics = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: TimeOffAnalytics is not implemented yet.');
  }, []);
  return (
    <>
  { /*TimeOffAnalytics */} 
 </>
  );
};

export default TimeOffAnalytics;
